import SyntheseEntityRecompositionController from './syntheseentities.recomposition.controller';

export default {
    template: require('./syntheseentities.recomposition.html'),
    controller: SyntheseEntityRecompositionController
};
